import * as React from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { FormErrors } from '@shared/ui-react/UtilComponents';
import { Button } from '@shared/ui-react/Button';


export class SingleMultiSelect extends React.PureComponent<{
    value: any;
    onChange: (value: any) => void;
    minItems?: number;
    maxItems?: number;
    style?: any;
    options: any[];
    showError?: boolean;
    wrapValueIntoArray?: boolean; // single value arrays need value to be represented as "[val]", while enums need pure value
    logicSwitch?: 'and' | 'or';
    onChangeLogicSwitch?: (value: 'and' | 'or') => void;
}, {}> {
    static defaultProps = {
        minItems: null,
        maxItems: null,
        style: null,
        showError: false,
        wrapValueIntoArray: true
    };

    render() {
        const error = this.getError;
        if (this.props.maxItems === 1) {
            return <>
                <Dropdown value={this.unwrapValue(this.props.value)}
                          options={this.props.options}
                          style={this.props.style}
                          showClear={true}
                          onChange={this.onChange}
                          className={error ? 'p-invalid' : null}/>
                {this.props.showError && <FormErrors error={error}/>}
            </>
        } else {
            return <>
                <MultiSelect value={this.props.value}
                             options={this.props.options}
                             style={this.props.style}
                             showSelectAll={false}
                             onChange={this.onChange}
                             className={error ? 'p-invalid' : null}
                             selectionLimit={this.props.maxItems ?? null}
                             panelHeaderTemplate={!this.props.onChangeLogicSwitch ? null : <div className='flex-row'>
                                <Button style={{ flexBasis: '50%'}} primary={this.props.logicSwitch === 'and'}
                                        onClick={() => this.props.onChangeLogicSwitch('and')}>{__('general.logic.and')}</Button>
                                <Button style={{ flexBasis: '50%'}} primary={this.props.logicSwitch === 'or'}
                                        onClick={() => this.props.onChangeLogicSwitch('or')}>{__('general.logic.or')}</Button>
                            </div>}
                    />
                {this.props.showError && <FormErrors error={error}/>}
            </>
        }
    }

    onChange = (e: any) => {
        this.props.onChange(this.props.wrapValueIntoArray ? this.wrapValue(e.value) : e.value);
    }

    wrapValue = (value: any) => {
        if (value == null) {
            return [];
        } else if (!Array.isArray(value)) {
            return [value];
        }
        return value;
    }

    unwrapValue = (value: any) => {
        if (value != null && Array.isArray(value)) {
            return value[0];
        }
        return value;
    }

    get getError(): any {
        let { value, minItems, maxItems } = this.props;
        if (value == null || (minItems == null && maxItems == null)) {
            return null;
        }
        value = this.wrapValue(value);

        if (minItems === 1 && maxItems === 1) {
            if (value.length === 0) {
                return { type: 'required' };
            }
        } else if (minItems != null) {
            if (value.length < minItems) {
                return { type: 'minOptions', minOptions: minItems };
            }
        }
        // no need to check maxSelectedOptions, component will restrict selection

        return null;
    }
}

